import React from 'react';
import useCoupon from 'hooks/useCoupon';
import useCustomer from 'hooks/useCustomer';
import styles from './SidebarBottomBanner.module.scss';

const SidebarBottomBanner: React.FC = () => {
  const { coupon } = useCoupon();
  const { isTrialCustomer, isExistingCustomer } = useCustomer();

  if (coupon) {
    return (
      <section className={styles.trial}>
        <div>
          <p className={styles.trial__copy}>
            今<span className={styles.fs14}>だけ</span>
            <span className={styles.fs20}>特別</span>
            <span className={styles.fs18}>!!</span>
          </p>
          <h2 className={styles.trial__title}>10%OFFでご案内</h2>
        </div>
        <a
          href={`https://docs.google.com/forms/d/e/1FAIpQLSeamgvUMXzKc_4p2SUWH17H7lUBc8vILfEwuRq_et8187dBbg/viewform?entry.1173614206=${coupon}`}
          target='_blank'
          rel='noreferrer'
        >
          <button className={styles.trial__button} type='button'>
            お申込みはこちら
          </button>
        </a>
      </section>
    );
  }
  if (isTrialCustomer || isExistingCustomer) {
    return (
      <section className={styles.trial}>
        <div>
          <p className={styles.trial__copy}>
            30
            <span className={`${styles.fs14} ${styles.mr3}`}>日間</span>
            <span className={styles.fs20}>無料</span>
            <span className={styles.fs18}>!!</span>
          </p>
          <h2 className={styles.trial__title}>トライアル実施中</h2>
        </div>
        <a href='https://forms.gle/4iQ3fDiLdMhn9tgX8' target='_blank' rel='noreferrer'>
          <button className={styles.trial__button} type='button'>
            お申込みはこちら
          </button>
        </a>
      </section>
    );
  }
  return null;
};

export default SidebarBottomBanner;
